import React, { useState, useEffect } from "react";
import BASE_URL from "../../configs/api";
import { IoClose } from "react-icons/io5";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const ContinueWatching = () => {
  const [movies, setMovies] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return;

    axios
      .get(`${BASE_URL}/api/video-continue/`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setMovies(res.data);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleSelectMovie = (movie) => {
    sessionStorage.setItem(
      `selectedEpisode-${movie.slug}`,
      JSON.stringify(movie)
    );
    navigate(
      `/xem-phim/${movie.phim.slug}/tap/${movie.phim.so_tap}?id=${movie.video_nguon}&ngonngu=${movie.phim.ngon_ngu}`
    );
  };

  const handleRemoveMovie = async (movieToRemove) => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        toast.error("Không có token đăng nhập");
        return;
      }

      await axios.post(
        `${BASE_URL}/api/video-progress/delete_progress/`,
        {
          video_nguon_id: movieToRemove.video_nguon,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success("Đã xóa khỏi danh sách xem tiếp");

      setMovies((prevMovies) =>
        prevMovies.filter(
          (item) => item.video_nguon !== movieToRemove.video_nguon
        )
      );
    } catch (error) {
      console.error("Error removing movie:", error);
      toast.error("Lỗi khi xóa phim khỏi danh sách");
    }
  };

  return (
    <div className="container min-h-[80vh]">
      <h2 className="text-xl md:text-2xl font-bold text-white mb-5">
        Lịch sử phim
      </h2>
      <div className="mb-6">
        <button className="px-5 py-2 mr-3 rounded-full text-sm font-medium transition-colors duration-200 bg-gray-200 text-black">
          Phim ({movies.length})
        </button>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-6">
        {movies.map((movie) => {
          return (
            <div
              key={movie.phim_id}
              className="movie-card transition-transform duration-200 ease-in-out"
            >
              <div className="relative rounded-lg overflow-hidden group">
                <div
                  onClick={() => handleSelectMovie(movie)}
                  className="relative group cursor-pointer"
                >
                  <img
                    src={movie.phim.poster_url}
                    alt={movie.ten_phim}
                    className="w-full h-auto aspect-[2.3/3] object-cover"
                  />
                  <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition duration-300" />
                </div>
                <div className="absolute top-2 left-2 gap-1 flex flex-col justify-center items-start z-20">
                  <div className="bg-teal-600/80 backdrop-blur-sm text-white text-[8px] leading-[10px] md:text-[10px] font-semibold px-2 py-0.5 lg:py-1 rounded-md shadow-md">
                    {movie.phim.ngon_ngu
                      ? movie.phim.ngon_ngu
                          .replace("vietsub", "PĐ")
                          .replace("thuyetminh", "TM")
                      : "Đang cập nhật"}
                  </div>
                  <div className="bg-orange-500/80 backdrop-blur-sm text-white text-[8px] leading-[10px] md:text-[10px] font-semibold px-2 py-0.5 lg:py-1 rounded-md shadow-md">
                    {(movie.phim.tinh_trang || "Đang cập nhật")
                      .replace(/Hoàn Tất/gi, "Full")
                      .trim() || "Đang cập nhật"}
                  </div>
                </div>
                <button
                  className="absolute top-2 right-2 bg-[#fff] hover:bg-neutral-100 text-black rounded-[5px] w-8 h-8 flex items-center justify-center transition-colors duration-200 z-20 opacity-[0.7]"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRemoveMovie(movie);
                  }}
                >
                  <IoClose className="h-4 w-4" />
                </button>
              </div>

              <div className="mt-4 w-full flex flex-col items-center ">
                <div className="w-[80%] h-1 bg-gray-700 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-orange-500"
                    style={{
                      width: `${
                        movie.duration > 0
                          ? Math.min(
                              (movie.progress / movie.duration) * 100,
                              100
                            )
                          : 0 
                      }%`,
                    }}
                  />
                </div>
                <div className="mt-2 text-center text-white/80 text-xs w-full">
                  {movie.duration > 0 && (
                    <>
                      <span>Tập {movie.phim.so_tap}</span> •{" "}
                      <span>{Math.floor(movie.progress / 60)}m / </span>
                      <span className="ml-1 text-gray-500">
                        {Math.floor(movie.duration / 60)}m
                      </span>
                    </>
                  )}
                  {!movie.duration && movie.so_tap && (
                    <span>Tập {movie.so_tap}</span>
                  )}
                </div>
              </div>

              <div className="mt-2 text-center">
                <div
                  onClick={() => handleSelectMovie(movie)}
                  className="text-white text-sm md:text-[14px] font-medium truncate hover:text-yellow-200 cursor-pointer line-clamp-none"
                  title={movie.phim.ten_phim}
                >
                  {movie.phim.ten_phim}
                </div>
                {movie.phim.ten_khac && (
                  <div className="hidden sm:block text-gray-400 text-xs line-clamp-1 truncate">
                    {movie.phim.ten_khac}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ContinueWatching;
